import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ScannedCodesEffects } from './scanned-codes.effects';
import { scannedCodesFeature } from './scanned-codes.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(scannedCodesFeature), EffectsModule.forFeature(ScannedCodesEffects)],
})
export class ScannedCodesStateModule {}
